// extracted by mini-css-extract-plugin
export default {"FormControl":"get-project-items-block-module__FormControl__VDooCXl","Box":"get-project-items-block-module__Box__S4pjzuh"};